import { useState, useEffect } from 'react';
import {useSelector} from 'react-redux';
import {cardVerificationLightStatusesConstants as lightStatus} from '../../constants';
import {useIsSupport} from '../access/useIsSupport';

export const useIsRequiredCardVerification = () => {
  const isSupport = useIsSupport();
  const verification = useSelector((state) => state.banking?.verification ?? null);
  const [checked, setChecked] = useState(false);
  const [required, setRequired] = useState(false);

  useEffect(() => {
    let isRequired;
    const isChecked = verification?.isChecked || false;
    if (isSupport || !isChecked) {
      isRequired = false;
    } else {
      isRequired = verification.isRequired && ![lightStatus.REFUSED, lightStatus.PENDING_FILE_UPLOADED].includes(verification.status);
    }
    if (isRequired !== required) setRequired(isRequired);
    if (isChecked !== checked) setChecked(isChecked);
  }, [isSupport, verification]); // eslint-disable-line react-hooks/exhaustive-deps

  return { checked, required };
}

